export default {
  GET_ALL: `#graphql
  query getFaqs($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getFaqs(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init: $init, final: $final)
    {
      docs {
        faq
        question
        answer
        brand
        active
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }
  }`,

  GET_CHAT: `#graphql
  query getFaqChat($brand: String!) {
    getFaqChat(brand: $brand) {
      brand
      text
      updatedBy
      updatedAt
      messages {
        role
        content
        author
        createdAt
      }
    }
  }`,

  SEND_CHAT: `#graphql
  mutation sendFaqChat($brand: String!, $message: String!) {
    sendFaqChat(brand: $brand, message: $message) {
      brand
      text
      updatedBy
      updatedAt
      messages {
        role
        content
        author
        createdAt
      }
    }
  }`,

  NEW: `#graphql
  mutation NewFaq($faq: FaqInput!) {
    newFaq(input: $faq)
    {
      faq
      question
      answer
      brand
      active
    }
  }`,

  UPDATE: `#graphql
  mutation UpdateFaq($faq: String!, $brand: String!, $faqUpdate: FaqUpdateInput!) {
    updateFaq(faq: $faq, brand: $brand, faqUpdate: $faqUpdate)
    {
      faq
    }
  }`,

  DELETE: `#graphql
  mutation DeleteFaq($faq: String!, $brand: String!) {
    deleteFaq(faq: $faq, brand: $brand)
    {
      faq
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/faq.js